import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiResponseObject } from '../models/responses/api-response-object';
import { FunctionDto } from '../models/FunctionDto';

 

@Injectable({
  providedIn: 'root'
})
export class FunctionsService {

  constructor(private httpClient: HttpClient) { }


  getAllFunctions(): Observable<ApiResponseObject<FunctionDto[]>> {
    ; 
   var result = this.httpClient.get<ApiResponseObject<FunctionDto[]>>(`${environment.apiUrl}/Functions`);
   return result;
 }
 
 SaveFunction(newContractRequest: FunctionDto): Observable<ApiResponseObject<FunctionDto>> {
  
   return this.httpClient.post<ApiResponseObject<FunctionDto>>(`${environment.apiUrl}/Functions`, newContractRequest);
 }

 updateFunction(updateContractRequest: FunctionDto): Observable<ApiResponseObject<FunctionDto>> {
  
   return this.httpClient.put<ApiResponseObject<FunctionDto>>(`${environment.apiUrl}/Functions`, updateContractRequest);
 }

 
 getById(id: number): Observable<ApiResponseObject<FunctionDto>> {
  return this.httpClient.get<ApiResponseObject<FunctionDto>>(`${environment.apiUrl}/Functions/${id}`);
}

getByDepartmentId(id: number): Observable<ApiResponseObject<FunctionDto[]>> {
  var  result = this.httpClient.get<ApiResponseObject<FunctionDto[]>>(`${environment.apiUrl}/Functions/GetByDepartment/${id}`);
 ;
  return result;
}


}
